<app-selection-modal
  [id]="id"
  [title]="title"
  [searchPlaceholder]="searchPlaceholder"
  [fetchConfig]="fetchConfig"
  [sections]="{
    content,
    contentHeader: shouldShowContentHeader ? contentHeader : null,
    disclaimer: sections.disclaimer,
    footer: sections.footer
  }"
  [filters]="filters"
  [emptyMessage]="emptyMessage"
  (cancel)="onCancel()"
>
  <ng-template #contentHeader>
    <!-- This div is needed for justify content space between. -->
    <div>
      <ng-container *ngTemplateOutlet="sections.contentHeader"></ng-container>
    </div>
    <mat-paginator
      *ngIf="fetchConfig.paginationStrategy === PaginationStrategy.PageBased"
      hidePageSize
      class="mat-paginator"
      [length]="totalItems$ | async"
      [pageSize]="fetchConfig.pageSize"
      [pageIndex]="pageIndex$ | async"
      [disabled]="isLoading$ | async"
      (page)="onPageChange($event)"
    ></mat-paginator>
  </ng-template>

  <ng-template #content let-templates>
    <mat-table
      [dataSource]="dataSource"
      [multiTemplateDataRows]="true"
      appIntersectionObserveElement
      #intersection="intersection"
      (isLastElementInView)="fetchNextItems()"
    >
      <ng-container
        *ngFor="let column of computedColumns; let isFirst = first"
        matColumnDef="{{ column.key }}"
      >
        <mat-header-cell *matHeaderCellDef [style.flex]="column.flex">
          <ng-container *ngTemplateOutlet="column.header"></ng-container>
        </mat-header-cell>
        <mat-cell *matCellDef="let item" [style.flex]="column.flex" [class.text-emphasis]="isFirst">
          <ng-container
            *ngTemplateOutlet="column.cell; context: { $implicit: item }"
          ></ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="loading">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let item">
          <div class="loader">
            <app-content-loader [blockCount]="1"></app-content-loader>
          </div>
        </mat-cell>
      </ng-container>

      <div *matNoDataRow>
        <ng-container *ngTemplateOutlet="templates.loading"></ng-container>
        <ng-container *ngTemplateOutlet="templates.empty"></ng-container>
      </div>

      <mat-header-row *matHeaderRowDef="columnNames; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: columnNames"></mat-row>
      <mat-row *matRowDef="let row; columns: ['loading']; when: showScrollBasedLoading"></mat-row>
    </mat-table>
  </ng-template>
</app-selection-modal>
